import React from "react";
import { useTranslation } from "react-i18next";
import { CONTRACT_LINK_CLASS_NAME } from "constants/moduleConstants/contract.constant";

const CheckboxMock = ({ checked = false }) => (
  <span
    className={`mt-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded border ${
      checked
        ? "border-kostebek-500 bg-kostebek-500 text-white"
        : "border-gray-300 bg-white dark:border-gray-600 dark:bg-gray-800"
    }`}
    aria-hidden
  >
    {checked ? (
      <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
        <path
          d="M2 6l3 3 5-5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ) : null}
  </span>
);

const WhitelabelContractPreview = ({
  showSignupContracts,
  selectedContracts = [],
}) => {
  const { t } = useTranslation();

  return (
    <div className="rounded-xl bg-gray-100 p-6 dark:bg-gray-900/60">
      <div className="mx-auto w-full max-w-lg rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-600 dark:bg-gray-800">
        <p className="mb-4 text-center text-sm font-semibold text-gray-800 dark:text-gray-100">
          {t("companies.form.whitelabelFields.contracts.preview.formTitle")}
        </p>

        {!showSignupContracts ? (
          <p className="rounded-lg border border-dashed border-gray-300 px-4 py-6 text-center text-sm text-gray-500 dark:border-gray-600 dark:text-gray-400">
            {t("companies.form.whitelabelFields.contracts.preview.hidden")}
          </p>
        ) : selectedContracts.length ? (
          <div className="space-y-3">
            {selectedContracts.map((contract) => {
              const label =
                contract.description ||
                contract.typeLabel ||
                t("companies.form.whitelabelFields.contracts.preview.fallbackLabel");

              return (
                <div
                  key={contract.contractversionid}
                  className="flex items-start gap-3 rounded-lg border border-gray-200 px-3 py-2.5 dark:border-gray-700"
                >
                  <CheckboxMock />
                  <span className="text-sm leading-snug text-gray-700 dark:text-gray-200">
                    {t("auth.signUp.form.contracts.approvePrefix")}{" "}
                    <span className={CONTRACT_LINK_CLASS_NAME}>{label}</span>{" "}
                    {t("auth.signUp.form.contracts.approveSuffix")}
                  </span>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="rounded-lg border border-dashed border-amber-300 bg-amber-50 px-4 py-6 text-center text-sm text-amber-800 dark:border-amber-700 dark:bg-amber-950/30 dark:text-amber-200">
            {t("companies.form.whitelabelFields.contracts.preview.noSelection")}
          </p>
        )}

        <p className="mt-4 text-center text-xs text-gray-400 dark:text-gray-500">
          {t("companies.form.whitelabelFields.contracts.preview.coreNote")}
        </p>
      </div>
    </div>
  );
};

export default WhitelabelContractPreview;
